import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { Sport } from '__generated__/globalTypes';
import { PromoBanner } from 'components/onboarding/PromoBanner';
import { useQuery } from 'hooks/graphql/useQuery';
import { useLocalStorage } from 'hooks/useLocalStorage';

import type {
  SignupPromoBannerQuery,
  SignupPromoBannerQueryVariables,
} from './__generated__/index.graphql';

const SIGNUP_PROMO_BANNER_QUERY = gql`
  query SignupPromoBannerQuery($sport: Sport!, $affiliate: Boolean!) {
    market {
      id
      onboardingConversionCredit(sport: $sport, affiliate: $affiliate) {
        id
        ...PromoBanner_conversionCredit
      }
    }
  }
  ${PromoBanner.fragments.conversionCredit}
` as TypedDocumentNode<SignupPromoBannerQuery, SignupPromoBannerQueryVariables>;

export const SignupPromoBanner = ({ sport }: { sport: Sport }) => {
  const [affiliate] = useLocalStorage('UTM_CAMPAIGN', undefined);
  const { data } = useQuery(SIGNUP_PROMO_BANNER_QUERY, {
    variables: {
      sport,
      affiliate: !!affiliate,
    },
    // should already be fetched in landing page
    fetchPolicy: 'cache-first',
  });
  const onboardingConversionCredit = data?.market.onboardingConversionCredit;
  if (!onboardingConversionCredit) {
    return null;
  }
  return (
    <PromoBanner leftAligned conversionCredit={onboardingConversionCredit!} />
  );
};
